import { useTranslation } from 'react-i18next';
import { AppToggleButton, AppToggleButtons } from '@/UI/AppToggleButtons';
import { ListIcon, SquaresIcon } from '@/UI/Icons';
import { useFplMigrationFlag } from '@/contexts/FplMigrationContext';
import { I18N_KEYS } from '@/language/keys';

export interface ViewLayoutSelectorProps {
  isListView: boolean;
  onChange: (isListView: boolean) => void;
}

/** Shared Dashboard/Archive list-grid selector with an exact legacy branch. */
export function ViewLayoutSelector({ isListView, onChange }: ViewLayoutSelectorProps) {
  const isFplMigrationEnabled = useFplMigrationFlag();
  const { t } = useTranslation();

  if (isFplMigrationEnabled) {
    return (
      <AppToggleButtons
        value={isListView ? 'list' : 'grid'}
        onChange={(value) => onChange(value === 'list')}
        isIcons
        aria-label={t(I18N_KEYS.DASHBOARD.VIEW_LAYOUT.ARIA)}
        options={[
          { value: 'list', label: <ListIcon />, 'aria-label': t(I18N_KEYS.DASHBOARD.VIEW_LAYOUT.LIST_ARIA) },
          { value: 'grid', label: <SquaresIcon />, 'aria-label': t(I18N_KEYS.DASHBOARD.VIEW_LAYOUT.GRID_ARIA) },
        ]}
      />
    );
  }

  return (
    <>
      <AppToggleButton
        value="list"
        selected={isListView}
        onClick={() => onChange(true)}
        isIcon
        btnW={32}
        btnH={32}
        svgSize={24}
        sx={{ border: 'none' }}
      >
        <ListIcon />
      </AppToggleButton>
      <AppToggleButton
        value="grid"
        selected={!isListView}
        onClick={() => onChange(false)}
        isIcon
        btnW={32}
        btnH={32}
        svgSize={24}
        sx={{ border: 'none' }}
      >
        <SquaresIcon />
      </AppToggleButton>
    </>
  );
}
